'use client'

import { Video } from 'lucide-react'
import { CHARACTER_THEMES } from '@/lib/character-themes'
import { cn } from '@/lib/utils'

interface CallCtaCardProps {
  label: string
  onCall: () => void
}

/** Tarjeta grande «📹 Hablar con Papá Noel en una llamada» bajo el historial. */
export function CallCtaCard({ label, onCall }: CallCtaCardProps) {
  return (
    <div data-testid="santa-chat-call-cta" className="px-4 pb-2">
      <button
        type="button"
        onClick={onCall}
        className={cn(
          'flex min-h-16 w-full items-center justify-center gap-3 rounded-2xl px-4 py-3 text-lg font-semibold pulse-glow',
          CHARACTER_THEMES.santa.videoCall.ctaButton
        )}
      >
        <Video aria-hidden className="size-7 shrink-0" />
        <span>{label}</span>
      </button>
    </div>
  )
}
